import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Tabs, Tab, Typography, Link, Button, IconButton, Snackbar, CircularProgress } from "@material-ui/core";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import "./exam-review-drawer.scss";
import samplePdf from '../../pdfs/peds.manual2.pdf';
import { getQuesFeedback, getQuesTutorFeedback, userDetailsFromToken } from "../../actions";
import ReactMarkdown from 'react-markdown';
import { Forum, Launch, Check, Clear } from "@material-ui/icons";
import QuestionFeedback from '../../components/exam-header/question-feedback';
import PhoneAuthSection from '../login/PhoneAuthSection';
import url from "../../constants/urlList";
import { api } from "../../services/apiService";
import { buildQLinkOAuthState } from "../../utils/attribution";
import { getActiveReferralCode } from "../../utils/referral";
import { resolveInitialTheme } from "../../utils/theme-preference";
// import googleLogo from "../../images/google-icon.png";
const googleLogo = require("../../images/google-icon.png").default;
const blurImg = require("../../images/blurred-exp.png").default;

let guideWindow = null;

const ExamReviewDrawer = (props) => {
  const { questionData, openDrawer, quizHistory, onPdfClose, isOpenPdf, pdfData, onFeedbackOpen,
    isTutor, isGuide, isReview, onGuideOpen, currentQuestionNum, isUserAcquisition, isUserLoggedIn, selectedAnswer = '', handleFetchQuestionMetadata = () => { }, questionMetadataError, isQuestionMetadataLoading = false, qlinkId, qlinkPlatform,
    // R3 (P0 blank-explanation fix): an answered question whose explanation
    // never arrived (A2 grade failed, metadata errored, or the reveal was
    // empty) must render an explicit unavailable/retry state — never a silent
    // blank. serverGradeError carries the A2 failure; isAnswered says the
    // question is graded/answered (so the unavailable state applies); the strip
    // for UNanswered questions is unchanged.
    serverGradeError, isAnswered = false, onRetryExplanation } = props;
  const [selectedTab, setSelectedTab] = useState('explanation');
  const [isPdf, setIsPdf] = useState(false);
  const [guideData, setGuideData] = useState({});
  const [pageNumber, setPageNumber] = useState(10);
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(600);
  const [searchText, setSearchText] = useState('');
  const [isTutorRole, setIsTutorRole] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  // Admin-only author byline. The email is no longer in the question payload
  // (QLearn-service #484 stripped it); fetch it per question from the
  // admin-guarded author endpoint so admins keep attribution and students
  // never receive it.
  const [authorEmail, setAuthorEmail] = useState("");
  const [quesFeedbackArr, setQuesFeedbackArr] = useState([]);
  const [quesTutorFeedbackArr, setQuesTutorFeedbackArr] = useState([]);
  const [loginFailed, setLoginFailed] = useState(false);
  const [authMethod, setAuthMethod] = useState('google'); // 'google' or 'phone'

  const pageRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const quesFeedback = useSelector((state) => {
    return state.getQuesFeedback;
  });

  const setQuesFeedbackRes = useSelector((state) => {
    return state.setQuesFeedback;
  });

  const quesTutorFeedback = useSelector((state) => {
    return state.getQuesTutorFeedback;
  });

  // B2 (REVIEW-SCOPE): resolve the theme the SAME way exam-header does — the
  // latest toggle (setUserPreference) wins over the loaded record
  // (getUserPreference). Subscribing to setUserPreference is what makes the
  // tab-label dark class re-render on an in-session theme toggle (the drawer
  // previously read getUserPreference only, which does not update on toggle).
  const userPreferenceData = useSelector((state) => {
    return state.setUserPreference?.preference || state.getUserPreference?.preference;
  });
  // Drive the dark-only tab-label class off the RESOLVED theme, not the raw
  // darkTheme field: resolveInitialTheme falls back to prefers-color-scheme when
  // no saved preference exists, so OS-defaulted-dark users (the cohort S6 newly
  // serves dark) get the dark token routing and avoid the ~1.3-1.8:1 C4 tab
  // fallback. It stays correct after an in-session toggle because a saved boolean
  // (now surfaced via setUserPreference above) short-circuits the OS fallback.
  const isDarkTheme = resolveInitialTheme(userPreferenceData) === 'dark';

  useEffect(() => {
    if (isGuide) {
      const channel = new BroadcastChannel('app-data');
      channel.addEventListener('message', (event) => {
        setGuideData(event.data);
      });
    }
    const role = window.localStorage.getItem('role');
    setIsTutorRole(role === 'ROLE_TUTOR');
    setIsAdmin(role === 'ROLE_ADMIN');

    return () => {
      if (guideWindow) {
        guideWindow.close();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (questionData) {
      setGuideData(questionData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionData]);

  useEffect(() => {
    if (setQuesFeedbackRes?.quesFeedback && setQuesFeedbackRes?.loading === false) {
      const questionId = questionData?.id;
      if (questionId) {
        dispatch(getQuesFeedback(questionId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setQuesFeedbackRes]);

  useEffect(() => {
    if (quesFeedback?.loading !== undefined && !quesFeedback?.loading) {
      setQuesFeedbackArr(quesFeedback.quesFeedback || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quesFeedback]);

  useEffect(() => {
    if (quesTutorFeedback?.loading !== undefined && !quesTutorFeedback?.loading) {
      setQuesTutorFeedbackArr(quesTutorFeedback.quesTutorFeedback);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quesTutorFeedback]);

  useEffect(() => {
    setPageWidth(pageRef?.current?.offsetWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageRef.current]);

  useEffect(() => {
    if (pdfData) {
      setPageNumber(pdfData.page);
      setSearchText(pdfData.text);
    }
  }, [pdfData]);

  useEffect(() => {
    const questionId = guideData?.id;
    if (questionId && !isUserAcquisition) {
      if (isTutorRole) {
        dispatch(getQuesTutorFeedback(questionId));
      } else {
        dispatch(getQuesFeedback(questionId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, guideData]);

  // Admin author byline: fetch per question. Non-admins never call it (and the
  // endpoint 403s them anyway); a failed/absent response just clears the line.
  useEffect(() => {
    const questionId = guideData?.id;
    if (!isAdmin || !questionId) {
      setAuthorEmail("");
      return;
    }
    // Clear immediately so navigating between questions never shows the
    // previous question's author while this fetch is in flight.
    setAuthorEmail("");
    let cancelled = false;
    api.getQuestionAuthor(questionId).then((res) => {
      if (!cancelled) {
        setAuthorEmail(res && !res.status && res.userEmail ? res.userEmail : "");
      }
    }).catch(() => {
      if (!cancelled) {
        setAuthorEmail("");
      }
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, guideData]);

  const getPageProps = () => {
    return {
      className: 'pdf-page',
      scale: 1,
      // renderTextLayer,
      width: pageWidth,
      customTextRenderer: (text) => {
        const splitText = text.str.split(searchText);

        if (splitText.length <= 1) {
          return text.str;
        }

        const matches = text.str.match(new RegExp(searchText, 'i'));

        return splitText.reduce((arr, element, index) => (matches[index] ? [
          ...arr,
          element,
          <mark key={index}>
            {matches[index]}
          </mark>,
        ] : [...arr, element]), []);
      }
    };
  }

  const pageProps = getPageProps();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  }

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const closePdf = () => {
    setIsPdf(false);
    onPdfClose();
  };

  useEffect(() => {
    setIsPdf(isOpenPdf);
  }, [isOpenPdf]);

  const convertUrl = (url) => {
    if (url.includes('youtube')) {
      return url.replace('watch?v=', 'embed/') + '?autoplay=1';
    }

    return url;
  }

  const onGuidePopOut = () => {
    if (!guideWindow) {
      let path = window.location.pathname;

      if (isReview) {
        path = path.replace('review', 'tutor/1');
      }

      guideWindow = window.open(path + '/guide/1', '_blank', 'width=800,height=700,left=700,popup');
      onGuideOpen();

      guideWindow.addEventListener('load', () => {
        guideWindow.addEventListener('beforeunload', (e) => {
          // e.preventDefault();
          guideWindow = null;
          // e.returnValue = true;
        });
      });
    } else {
      alert('Guide already open');
    }
  }

  const getTransformedText = (text) => {
    if (text.includes('_')) {
      return text.replace('_', ' ');
    }

    return text;
  }

  const sendToLogin = () => {
    window.location = "/";
  }

  const loginSuccessListener = (response) => {
    const result = response.data.results;

    if (result?.accessToken) {
      window.localStorage.setItem("token", result.accessToken);
      dispatch(userDetailsFromToken());
      setLoginFailed(false);
    } else {
      setLoginFailed(true);
    }
  };

  const onGoogleSignUp = () => {
    window.removeEventListener("message", loginSuccessListener);

    let oauthUrl = `${url.domain}/qlearn/oauth2/authorization/google`;

    const params = new URLSearchParams();
    if (isUserAcquisition && qlinkId) {
      const platform = qlinkPlatform || 'unknown';
      const qLinkState = buildQLinkOAuthState({ qlinkId, platform });
      if (qLinkState) {
        params.set('state', qLinkState);
      }
    }
    const referralCode = getActiveReferralCode(window.localStorage);
    if (referralCode) params.set('ref', referralCode);
    const queryStr = params.toString();
    if (queryStr) oauthUrl += `?${queryStr}`;

    window.open(oauthUrl, "Sign In", "height=400,width=600");
    window.addEventListener("message", loginSuccessListener, false);
  };

  // Strip-safe acquisition states (C2 flip gate F1): with the in-quiz answer
  // strip on, the server never sends option.correctAnswer to a QLink viewer
  // (no quiz context, so the reveal fail-closes — QLS InQuizRevealService),
  // and a missing key must render NEITHER state. The unguarded `!==` below
  // read `undefined !== answer` as "wrong" and painted every answered
  // question red for logged-in acquisition users. With a non-empty key
  // (today, strip off) both values are unchanged.
  const acquisitionCorrectAnswer = typeof guideData?.option?.correctAnswer === 'string' ? guideData.option.correctAnswer.trim() : '';
  const isUserAcquisitionCorrectAns = isUserLoggedIn && isUserAcquisition && selectedAnswer && !!acquisitionCorrectAnswer && acquisitionCorrectAnswer === selectedAnswer?.trim();
  const isUserAcquisitionWrongAns = isUserLoggedIn && isUserAcquisition && selectedAnswer && !!acquisitionCorrectAnswer && acquisitionCorrectAnswer !== selectedAnswer?.trim();
  const showQuestionMetadataLoading = isQuestionMetadataLoading && !questionMetadataError;
  // R3: student-visible explanation content. The full `explanation` is admin-
  // only (rendered below), so for a student the content is brief/additional;
  // admins also see `explanation`. A held reveal with none of these — or a
  // grade/metadata error — is the silent-blank the P0 came from.
  const hasExplanationContent = !!(guideData?.briefExplanation || guideData?.additionalExplanation || (isAdmin && guideData?.explanation));
  const showExplanationUnavailable = isUserLoggedIn && !isUserAcquisition && !showQuestionMetadataLoading && isAnswered && !hasExplanationContent;
  const explanationErrorCode = serverGradeError && serverGradeError !== true ? serverGradeError : null;
  const handleExplanationRetry = () => {
    if (typeof onRetryExplanation === 'function') {
      onRetryExplanation();
    } else {
      handleFetchQuestionMetadata();
    }
  };

  return (
    <>
      <Snackbar open={loginFailed} onClose={() => setLoginFailed(false)} autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <>
          <Box className="success-warn">
            Login Unsuccessful
          </Box>
        </>
      </Snackbar>
      {isPdf &&
        <Box component="div" m={1} ref={pageRef}>
          <Button
            className="close-btn"
            onClick={closePdf}
          >
            X
          </Button>
          <Document file={samplePdf} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                {...pageProps}
                key={`page_${index + 1}`}
                inputRef={
                  pageNumber === index + 1 ? (ref) => ref && ref.scrollIntoView() : null
                }
                pageNumber={index + 1}
              />
            ))
            }
          </Document>
        </Box>
      }
      {!isPdf &&
        <Box component="div" className="drawer-cont">
          <Box className={`${(quizHistory?.correct || isUserAcquisitionCorrectAns) ? 'correct-ans' : quizHistory?.correct === false || isUserAcquisitionWrongAns ? 'wrong-ans' : ''} exp-header`}>
            <Box className="header-lbls">
              <Box component="h2" className="detailed-guidance-lbl">Detailed Guidance</Box>
              {!isTutorRole && !isUserAcquisition &&
                <Box className="icons-wrap">
                  {quizHistory?.correct && <><Check className="correct-icon"></Check> Correct</>}
                  {quizHistory?.correct === false && <><Clear className="incorrect-icon"></Clear>Incorrect</>}
                </Box>
              }
            </Box>
            {(isTutorRole && !isGuide) &&
              <IconButton
                onClick={() => onGuidePopOut()}
                title="Pop Out"
                className="pop-out-icon"
              >
                <Launch />
              </IconButton>
            }
          </Box>
          <Tabs
            value={selectedTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            className={`${(quizHistory?.correct || isUserAcquisitionCorrectAns) ? 'correct-ans' : quizHistory?.correct === false || isUserAcquisitionWrongAns ? 'wrong-ans' : ''} review-tab`}
          >
            <Tab className={`${isDarkTheme ? 'drawer-cont-tab-lbl' : ''}`} label="Explanation" value="explanation" />
            {!isUserAcquisition && <Tab className={`${isDarkTheme ? 'drawer-cont-tab-lbl' : ''}`} label="Info" value="info" />}
            {!isUserAcquisition && <Tab className={`${isDarkTheme ? 'drawer-cont-tab-lbl' : ''}`} label="Feedback" value="feedback" />}
          </Tabs>

          {selectedTab === "explanation" && (
            <>
              {(isUserLoggedIn) &&
                <Box p={3} className="tabs-cont" aria-busy={showQuestionMetadataLoading}>
                  {showQuestionMetadataLoading ? (
                    <Box className="explanation-loading-state" role="status" aria-live="polite">
                      <CircularProgress size={30} className="explanation-loading-spinner" />
                      <Typography className="explanation-loading-title">Loading explanation...</Typography>
                      <Typography className="explanation-loading-copy">
                        Getting the detailed guidance for this question.
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {openDrawer && guideData?.videoLinks?.length > 0 && (
                        <iframe title={guideData?.id} allow='autoplay;fullscreen' id="video" width="420" height="345"
                          src={convertUrl(guideData?.videoLinks[0])}>
                        </iframe>
                      )}
                      {guideData?.option?.correctAnswer && (
                        <Box className="ans-item">The correct answer is <span className="correct-ans-lbl">{guideData?.option?.correctAnswer}</span></Box>
                      )}

                      {isAdmin &&
                        <Box className="exp-text MuiTypography-body1 content-body"><ReactMarkdown>{guideData?.explanation}</ReactMarkdown></Box>
                      }

                      {guideData?.briefExplanation &&
                        <Box className="exp-text brief-exp MuiTypography-body1 additional-exp content-body"><ReactMarkdown>{guideData?.briefExplanation}</ReactMarkdown></Box>
                      }

                      {guideData?.additionalExplanation &&
                        <Box className="exp-text MuiTypography-body1 additional-exp content-body"><ReactMarkdown>{guideData?.additionalExplanation}</ReactMarkdown></Box>
                      }

                      {/* R3: one explicit unavailable/error state — covers a
                          metadata fetch error, a failed A2 grade, AND an empty
                          reveal on an answered question. Never a silent blank.
                          Reuses the loading-state block styling. */}
                      {showExplanationUnavailable && (
                        <Box className="explanation-loading-state explanation-unavailable-state" role="status" aria-live="polite">
                          <Typography className="explanation-loading-title" color="error">
                            We couldn't load the explanation
                          </Typography>
                          <Typography className="explanation-loading-copy">
                            {questionMetadataError
                              ? questionMetadataError
                              : "The detailed guidance for this question isn't available right now."}
                            {explanationErrorCode ? ` (error ${explanationErrorCode})` : ''}
                          </Typography>
                          <Button
                            variant="text"
                            color="primary"
                            className="explanation-retry-btn"
                            onClick={handleExplanationRetry}
                            style={{ textTransform: 'none' }}
                          >
                            Retry
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              }

              {(isUserAcquisition && !isUserLoggedIn) &&
                <Box className="user-acq-cont">
                  <img src={blurImg} alt="Qlearn" />

                  <Box className="user-acq-login-box">
                    <Tabs
                      value={authMethod}
                      onChange={(e, newValue) => setAuthMethod(newValue)}
                      centered
                      indicatorColor="primary"
                      textColor="primary"
                      style={{ marginBottom: '20px', width: '100%' }}
                    >
                      <Tab label="Google Sign In" value="google" />
                      <Tab label="Phone Sign In" value="phone" />
                    </Tabs>

                    {authMethod === 'google' && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        className="google-btn"
                        id="google_login_btn"
                        onClick={onGoogleSignUp}
                      >
                        <img alt="google" src={googleLogo} width='30' height='30' className="logo" />
                        Sign In with Google
                      </Button>
                    )}

                    {authMethod === 'phone' && (
                      <PhoneAuthSection />
                    )}
                  </Box>
                </Box>
              }
            </>
          )}

          <Box
            p={3}
            className={
              selectedTab === "resources" ? "resource-list" : "resource-list hide"
            }
          >
            {guideData?.refLinks?.map((item, index) => (
              <Link
                href={guideData?.refLinks}
                variant="body2"
                target="_blank"
                rel="noopener"
                key={index}
              >
                Reference link {index + 1}
              </Link>
            ))}

            {guideData?.videoLinks?.length > 0 && (
              <video controls id="video" preload="metadata">
                <source src={guideData?.videoLinks[0]} type="video/mp4"></source>
              </video>
            )}
          </Box>

          {selectedTab === "info" && (
            <Box p={3} className="tabs-cont">
              <Box component="div" className="info-list-items">
                <Typography className="label">Discipline</Typography>
                <Typography className="item-value">
                  {guideData?.categories?.discipline?.join(", ")}
                </Typography>
              </Box>
              <Box component="div" className="info-list-items">
                <Typography className="label"> Organ System </Typography>
                <Typography className="item-value">
                  {guideData?.categories?.organSystem?.join(", ")}
                </Typography>
              </Box>
              <Box component="div" className="info-list-items">
                <Typography className="label"> Exam Type </Typography>
                <Typography className="item-value">
                  {guideData?.categories?.examType?.join(", ")}
                </Typography>
              </Box>
              <Box component="div" className="info-list-items">
                <Typography className="label"> Topics </Typography>
                <Typography className="item-value">
                  {guideData?.medicalCategories?.topics?.join(", ")}
                </Typography>
              </Box>
              <Box component="div" className="info-list-items">
                <Typography className="label"> Subtopics </Typography>
                <Typography className="item-value">
                  {guideData?.medicalCategories?.subtopics?.join(", ")}
                </Typography>
              </Box>
              {isAdmin && (guideData?.userEmail || authorEmail) &&
                <Box component="div" className="info-list-items">
                  <Typography className="label"> Author </Typography>
                  <Typography className="item-value">
                    {guideData?.userEmail || authorEmail}
                  </Typography>
                </Box>
              }
              {!isTutor &&
                <>
                  <Box component="div" className="info-list-items">
                    <Typography className="label"> Time Spent Testing </Typography>
                    <Typography className="item-value">
                      {Math.floor(((quizHistory?.timeSpent || 0) / 60) % 60) < 10 && 0}
                      {Math.floor(((quizHistory?.timeSpent || 0) / 60) % 60)}:
                      {Math.floor((quizHistory?.timeSpent || 0) % 60) < 10 && 0}
                      {Math.floor((quizHistory?.timeSpent || 0) % 60)}
                    </Typography>
                  </Box>
                  <Box component="div" className="info-list-items">
                    <Typography className="label"> Time Spent Reviewing </Typography>
                    <Typography className="item-value">
                      {Math.floor(((quizHistory?.reviewTimeSpent || 0) / 60) % 60) < 10 && 0}
                      {Math.floor(((quizHistory?.reviewTimeSpent || 0) / 60) % 60)}:
                      {Math.floor((quizHistory?.reviewTimeSpent || 0) % 60) < 10 && 0}
                      {Math.floor((quizHistory?.reviewTimeSpent || 0) % 60)}
                    </Typography>
                  </Box>
                </>
              }
            </Box>
          )}

          {selectedTab === "feedback" &&
            <>
              {!isTutorRole && !isAdmin &&
                <Box p={3} className="tabs-cont">
                  {quesFeedbackArr?.length > 0 && quesFeedbackArr?.map((item, index) =>
                    <Box component="div" className="info-list-items feedback" key={index}>
                      <Box className="label1">{item?.user?.email}</Box>
                      <Box className="item-row">
                        <Typography className="item-value">
                          Error Suspected: {item?.isError === 'Y' ? 'Yes' : 'No'}
                        </Typography>
                        {item?.rating > 0 &&
                          <Typography className="item-value">
                            Quality Rating: {item?.rating}
                          </Typography>
                        }
                        {item?.topic &&
                          <Typography className="item-value">
                            Topic: {getTransformedText(item?.topic)}
                          </Typography>
                        }
                        {item?.explanationType &&
                          <Typography className="item-value">
                            Error location: {getTransformedText(item?.explanationType)}
                          </Typography>
                        }
                      </Box>

                      {item?.comment &&
                        <Typography className="item-value">
                          {item?.comment}
                        </Typography>
                      }
                    </Box>
                  )}
                  {!quesFeedbackArr?.length &&
                    <Box className="no-feedback-cont">
                      <Typography className="item-value">No feedback yet.
                      </Typography>
                      {!isUserAcquisition &&
                        <IconButton
                          className="quesfeedback-btn"
                          onClick={() => onFeedbackOpen(true)}
                          title="Question Feedback"
                        >
                          <Forum />
                        </IconButton>
                      }
                    </Box>
                  }
                </Box>
              }
              {isAdmin &&
                <Box p={3} className="tabs-cont">
                  {quesTutorFeedbackArr?.length > 0 && quesTutorFeedbackArr.map((item, index) =>
                    <Box component="div" className="info-list-items feedback" key={index}>
                      <Box className="label1">From: {item?.user?.email}</Box>
                      <Box className="item-row-box">
                        <Box className="label-box">STEM</Box>
                        <Typography className="item-value-box">
                          Quality: {getTransformedText(item?.stem.quality)}.
                          Difficulty: {getTransformedText(item?.stem.difficulty)}.
                          Errors: {getTransformedText(item?.stem.errors)}.
                        </Typography>
                        <Box className="label-box">EXPLANATION</Box>
                        <Typography className="item-value-box">
                          Quality: {getTransformedText(item?.explanation.quality)}.
                          Errors: {getTransformedText(item?.explanation.errors)}.
                        </Typography>
                        {(item?.improvementSuggestions?.stem ||
                          item?.improvementSuggestions?.explanation ||
                          item?.improvementSuggestions?.expandedExplanation)
                          && <>
                            <Box className="label-box">Improvement Suggestions</Box>
                            {item?.improvementSuggestions?.stem &&
                              <Typography component='span' className="item-value-box">
                                Stem: {getTransformedText(item?.improvementSuggestions?.stem)}, &nbsp;
                              </Typography>
                            }
                            {item?.improvementSuggestions?.explanation &&
                              <Typography component='span' className="item-value-box">
                                Explanation: {getTransformedText(item?.improvementSuggestions?.explanation)}, &nbsp;
                              </Typography>
                            }

                            {item?.improvementSuggestions?.expandedExplanation &&
                              <Typography component='span' className="item-value-box">
                                Expanded Explanation: {getTransformedText(item?.improvementSuggestions?.expandedExplanation)}.
                              </Typography>
                            }
                          </>
                        }
                      </Box>
                    </Box>
                  )}
                  {!quesTutorFeedbackArr?.length &&
                    <Box className="no-feedback-cont">
                      <Typography className="item-value">No feedback yet
                      </Typography>

                      {/* <IconButton
                        className="quesfeedback-btn"
                        onClick={() => onFeedbackOpen(true, guideData?.id)}
                        title="Question Feedback"
                      >
                        <Forum />
                      </IconButton> */}
                    </Box>
                  }
                </Box>
              }
              {
                isTutorRole &&
                <QuestionFeedback
                  className="ques-feedbk-modal"
                  questionData={questionData}
                  isGuide={isGuide}
                  currentQuestion={currentQuestionNum} />
              }
            </>
          }
        </Box>
      }
    </>
  );
};

export default ExamReviewDrawer;
